import { customizeCraftJsComponent } from '../../helpers';
import { EditorInput } from '../EditorInput';
import { EditorLoginIdInputSettings } from '../EditorLoginIdInputSettings';

export const EditorCustomLoginIdInput = customizeCraftJsComponent(EditorInput, {
	name: 'Custom Login ID Input',
	props: {
		name: 'externalId',
		type: 'text',
		placeholder: 'Custom Login ID',
		label: 'Custom Login ID',
		autoComplete: null as any // we cannot use undefined because we getting the uncontrolled to controlled warning, and empty string is adding the attribute to the dom
	},
	related: {
		settings: EditorLoginIdInputSettings
	}
});
